module.exports = __webpack_public_path__ + "static/media/podium_1.29badd13.png";